// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1Dhoc","label":"SetPasswdForm_label__2Okb-"};